<template>
  <div class="cities-table-wrapper">
    <div class="cities-table">
      <Filter
          :labels="labels"
          v-bind:language="language"
      />
      <CitiesTable
          v-bind:language="language"
          v-bind:cities="filteredCities"
      />
      <Map
          v-if="isLoad"
          v-bind:lat="lat"
          v-bind:lng="lng"
      />
    </div>
  </div>
</template>

<script>
import Filter from "@/components/Filter";
import CitiesTable from "@/components/CitiesTable";
import Map from "@/components/Map";
import {ChangeSelected} from "@/services/change-selected";
import {CitiesModel} from "@/models/cities-model";
import {DetectLanguage} from "@/services/detect-language";
import {FilterModel} from "@/models/filter-model";
import {LanguageModel} from "@/models/language-model";

export default {
  name: 'App',
  components: {
    Filter,
    CitiesTable,
    Map
  },
  data() {
    return {
      labels: [],
      cities: [],
      filteredCities: [],
      lat: 0,
      lng: 0,
      isLoad: true,
      language: {}
    }
  },
  mounted() {

    const citiesModel = new CitiesModel();
    const filterModel = new FilterModel();
    const languageModel = new LanguageModel();
    const detectLanguageService = new DetectLanguage();
    const lang = detectLanguageService.getLanguage();

    languageModel
        .getLanguageTranslate(lang)
        .then((response) => {
          this.language = response.data;
        });

    citiesModel
        .getCities(lang)
        .then((response) => {
          this.cities = response.data;
          this.filteredCities = response.data;
          this.isLoad = true;
          this.lat = this.cities[0].lat;
          this.lng = this.cities[0].lng;
        });

    filterModel
        .getLabels(lang)
        .then((response) => {
          this.labels = response.data;
        });

    this.emitter.on("onSelected", ({id}) => {
      const appModel = ChangeSelected(id, this.cities);
      this.lat = appModel.getLat();
      this.lng = appModel.getLng();
      this.filteredCities = appModel.getListItems();
    });

    this.emitter.on('onSelectedFilter', ({filterCity}) => {
      this.filteredCities = this.cities.filter((item) => {
        if (filterCity == 0) return true;
        return item.city === filterCity;
      });
    });

    this.emitter.on('onFilterInput', ({input}) => {
      this.filteredCities = this.cities.filter((item) => {
        const lowerInput = input.toLowerCase();
        const itemName = item.name.toLowerCase();
        return itemName.startsWith(lowerInput);
      });
    });
  }
}
</script>

<style lang="scss">
.cities-table-wrapper {
  max-width: 1165px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

th {
  font-family: 'Arial', sans-serif;
}

.cities-table {
  display: flex;
  flex-direction: column;
  width: 100%;
}
</style>
